module.exports = __webpack_public_path__ + "img/crea-ristorante-logo-chiaro.973ab3e.svg";